import cn from 'classnames';
import { useLocale } from 'next-intl';

import ArticleShareButton from './ArticleShareButton';
import { ShareOption } from './config';

import { Language } from 'types/lang';

const defaultShareOptions: ShareOption[] = ['facebook', 'linkedin', 'twitter', 'messenger', 'whatsapp'];
const shareOptions: Partial<Record<Language, ShareOption[]>> = {
  de: [...defaultShareOptions, 'xing'],
  ru: [...defaultShareOptions, 'vk', 'telegram', 'viber'],
};

interface ArticleShareBarProps {
  className?: string;
  title?: string;
  slug: string;
  options?: ShareOption[];
}
export default function ArticleShareBar({ className, title, slug, options }: ArticleShareBarProps) {
  const locale = useLocale();
  const currentShareOptions = options || shareOptions[locale] || defaultShareOptions;

  const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || 'https://trans.info';
  const url = `${baseUrl}/${locale}/${slug}`;

  return (
    <div className={cn('flex items-center', className)}>
      {title && <p className="mr-2 hidden text-premium-900 md:block dark:text-white">{title}</p>}
      {currentShareOptions.map((option) => (
        <ArticleShareButton className="mr-1" key={option} url={url} option={option} />
      ))}
    </div>
  );
}
